import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

const selectedQuantities = new Map();

export class HdBundleSelectorComponent extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.addEventListener('change', this.#onChange, { signal: this.#controller.signal });
    queueMicrotask(() => this.#sync());
  }

  updatedCallback() {
    super.updatedCallback();
    queueMicrotask(() => this.#sync());
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  syncQuantityOptions() {
    this.#sync();
  }

  #sync() {
    if (!this.isConnected) return;
    const form = this.closest('form');
    const input = form?.querySelector('input[name="quantity"]');
    const choices = this.querySelector('fieldset');
    if (!(input instanceof HTMLInputElement) || !(choices instanceof HTMLFieldSetElement)) return;
    const native = input.closest('quantity-selector-component');
    const cartQuantity = native?.getCurrentValues?.().cartQuantity || 0;
    const stock = Number(this.dataset.stock);
    const inventoryMax = stock < 0 ? Infinity : Math.max(0, stock - cartQuantity);
    const nativeMax = native?.getEffectiveMax?.() ?? Infinity;
    const max = Math.min(inventoryMax, nativeMax);
    const min = Number(input.min) || 1;
    const step = Number(input.step) || 1;
    const radios = [...this.querySelectorAll('input[type="radio"]')];
    for (const radio of radios) {
      const quantity = Number(radio.value);
      radio.disabled = this.dataset.available !== 'true' || quantity > max || quantity < min || (quantity - min) % step !== 0;
    }
    const desired = selectedQuantities.get(this.dataset.productId) ?? 2;
    const selected = radios.find(radio => Number(radio.value) === desired && !radio.disabled) || radios.find(radio => !radio.disabled);
    if (!selected) {
      choices.hidden = true;
      this.removeAttribute('data-ready');
      return;
    }
    this.#apply(Number(selected.value));
    choices.hidden = false;
    this.setAttribute('data-ready', '');
  }

  #onChange = (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio' || radio.disabled) return;
    selectedQuantities.set(this.dataset.productId, Number(radio.value));
    this.#apply(Number(radio.value));
  };

  #apply(quantity) {
    const form = this.closest('form');
    const input = form?.querySelector('input[name="quantity"]');
    if (!(input instanceof HTMLInputElement)) return;
    const native = input.closest('quantity-selector-component');
    input.value = String(quantity);
    native?.setValue?.(String(quantity));
    native?.updateButtonStates?.();
    const productForm = this.closest('product-form-component');
    if (productForm) productForm.dataset.quantityDefault = String(quantity);
    for (const radio of this.querySelectorAll('input[type="radio"]')) radio.checked = Number(radio.value) === quantity;
    native?.dispatchEvent(new QuantitySelectorUpdateEvent(quantity));
  }
}

export class HdCartOfferComponent extends Component {
  async addSecond() {
    const button = this.querySelector('button');
    const cartItems = this.closest('cart-items-component');
    if (!(button instanceof HTMLButtonElement) || !cartItems?.updateQuantity || button.disabled) return;
    button.disabled = true;
    try {
      await Promise.all(cartItems.constructor.pendingQuantityUpdates || []);
      if (!this.isConnected) return;
      const row = cartItems.querySelector('.cart-items__table-row[data-key]');
      if (row?.dataset.key !== this.dataset.lineKey) return;
      await cartItems.updateQuantity({ line: 1, quantity: 2, action: 'change' });
    } finally {
      if (button.isConnected) button.disabled = false;
    }
  }
}

if (!customElements.get('hd-bundle-selector-component')) customElements.define('hd-bundle-selector-component', HdBundleSelectorComponent);
if (!customElements.get('hd-cart-offer-component')) customElements.define('hd-cart-offer-component', HdCartOfferComponent);

